import { createContext, useContext } from 'react'

interface AppointmentInteractionContextValue {
  onAppointmentSelect: ((appointmentId: string) => void) | undefined
}

const AppointmentInteractionContext = createContext<AppointmentInteractionContextValue>({
  onAppointmentSelect: undefined,
})

export const AppointmentInteractionProvider = AppointmentInteractionContext.Provider

export function useAppointmentInteractionContext(): AppointmentInteractionContextValue {
  return useContext(AppointmentInteractionContext)
}
